import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ISystemParams } from '../interfaces/public.interface';

@Injectable({
  providedIn: 'root',
})
export class PublicApiService {
  private readonly httpClient = inject(HttpClient);

  public getPublicParameters(): Observable<ISystemParams> {
    return this.httpClient.get<ISystemParams>(
      `${environment.API_URL}/public/parameters`,
    );
  }
}
